import { render, staticRenderFns } from "./BannerProuni.vue?vue&type=template&id=4c1f7d48&scoped=true&lang=pug&"
import script from "./BannerProuni.vue?vue&type=script&lang=js&"
export * from "./BannerProuni.vue?vue&type=script&lang=js&"
import style0 from "./BannerProuni.styl?vue&type=style&index=0&id=4c1f7d48&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1f7d48",
  null
  
)

export default component.exports